<template><div></div></template>

<script>
import L from "leaflet";
export default {
  props: ["map", "options"],
  data() {
    return {
      polygons: [],
      popup: [],
      customIconCenter: [],
      polygon: [],
      selectedPolygonIds: [],
      editingPolygonId: null,
      color: null,
    };
  },
  methods: {
    show() {
      this.options.forEach((e) => {
        if (e.lat !== null && e.polygon !== null) {
          this.polygons = this.options.map((option) => ({
            ...option,
            originalColor: option.color,
            editing: false,
            vertices: option.polygon,
            center: [option.lat, option.lng],
            editLatLng: false,
          }));
        }
      });
      this.createPolygons();
    },
    createPolygons() {
      this.polygons.forEach((poly) => {
        if (!poly.center.length == 0 && !poly.vertices.length == 0) {
          const polygon = L.polygon(poly.vertices, {
            color: "black",
            fillColor: poly.color,
            fillOpacity: 0.6,
          }).addTo(this.map);

          polygon.on("click", (e) => this.choosingPolygon(poly.id, e));
          polygon.on("mouseover", (e) => this.populCursor(e, poly.id));
          polygon.on("mouseout", () => this.clearMarkerPopul());

          this.polygon.push(polygon);
        }
      });
    },
    choosingPolygon(id, e) {
      const polygon = this.polygons.find((p) => p.id === id);
      if (!polygon) return;

      const isCtrlPressed = e.originalEvent.ctrlKey;

      if (isCtrlPressed) {
        const index = this.selectedPolygonIds.indexOf(id);
        if (index === -1) {
          this.selectedPolygonIds.push(id);
          polygon.editing = true;
          polygon.color = "blue";
        } else {
          this.selectedPolygonIds.splice(index, 1);
          polygon.editing = false;
          polygon.color = this.color;
        }
      } else {
        // обычный клик — сброс всех и выбор одного
        this.polygons.forEach((p) => {
          p.editing = false;
          p.color = p.originalColor || this.color;
        });
        this.selectedPolygonIds = [id];
        polygon.editing = true;
        polygon.color = "blue";
      }

      this.$emit("input", [...this.selectedPolygonIds]);
      this.clearPolygon();
      this.createPolygons();
    },
    disableEditing() {
      if (this.editingPolygonId === null) return;

      const polygon = this.polygons.find((p) => p.id === this.editingPolygonId);

      if (!polygon) return;

      polygon.editing = false;
      polygon.color = this.color;
    },
    populCursor(e, id) {
      this.clearMarkerPopul();
      if (e) {
        this.polygons.forEach((populs) => {
          if (id == populs.id) {
            if (!populs.editing) {
              this.createCenterMarker(id);
              let popup = L.popup()
                .setLatLng([e.latlng.lat, e.latlng.lng])
                .setContent(
                  `<p>Район: ${populs.id}<br />Название: ${populs.name}<br/>Зона: ${populs.group}</p>`
                )
                .openOn(this.map);

              this.popup.push(popup);
            }
          }
        });
      }
    },
    createCenterMarker(id) {
      this.clearMarkerPopul();
      this.polygons.forEach((markerCenter) => {
        if (id == markerCenter.id) {
          const customIconCenter = L.divIcon({
            className: "custom-icon-center",
            html: '<div style="border: 2px solid black; border-radius: 50%; width: 13px; height: 13px;"><div style="border: 1px solid black; border-radius: 50%; width: 5px; height: 5px; margin: 2px; background-color: black;"></div></div>',
            iconSize: [10, 10],
            iconAnchor: [10, 10],
          });

          const iconCenter = L.marker(markerCenter.center, {
            icon: customIconCenter,
          }).addTo(this.map);

          this.customIconCenter.push(iconCenter);
        }
      });
    },
    clearMarkerPopul() {
      if (this.popup) this.popup.forEach((icon) => icon.remove());
      this.popup = [];
      if (this.customIconCenter)
        this.customIconCenter.forEach((icon) => icon.remove());
      this.customIconCenter = [];
    },
    clearPolygon() {
      if (this.polygon) this.polygon.forEach((poly) => poly.remove());
      this.polygon = [];
    },
  },
};
</script>

<style lang="scss" scoped></style>
